// Module
var code = "<div class=\"grid_division\"> <div class=\"main_grid\"> <div> <div class=\"mishion_history\"> <div class=\"mission_title\">Users</div> </div> <div class=\"text-right\" if-has-permissions=\"'userModify'\"> <a class=\"btn btn-secondary\" ui-sref=\"^.add\"> <span> <i class=\"fa fa-plus\"></i> ADD User </span> </a> </div> <users-main-grid> </users-main-grid> </div> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'user/pages/main/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;